import { useState } from 'react';

const BO_HINT_VISIBLE_THRESHOLD = 2;

export function useBoUsageHint(): [boolean, () => void] {
  const [counter, setCounter] = useState(() => {
    if (typeof window !== 'undefined') {
      const storedCounter = localStorage.getItem('teetsh-bo-usage-counter');

      return storedCounter ? parseInt(storedCounter, 10) : 0;
    }
    return 0;
  });

  const incrementBoUsage = () => {
    const newCounter = counter + 1;
    setCounter(newCounter);

    if (typeof window !== 'undefined') {
      localStorage.setItem('teetsh-bo-usage-counter', String(newCounter));
    }
  };

  const isBoUsageHintVisible = counter < BO_HINT_VISIBLE_THRESHOLD;

  return [isBoUsageHintVisible, incrementBoUsage];
}
